/**
 * MWS Portal Services
 * REST Services der Portal-Anwendung MWS
 *
 * The version of the OpenAPI document: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type StateType = 'CLOSED' | 'CHECKED' | 'OPENED' | 'COMPLAINED' | 'INVENTORY_FAILURE' | 'STORED';

export const StateType = {
    Closed: 'CLOSED' as StateType,
    Checked: 'CHECKED' as StateType,
    Opened: 'OPENED' as StateType,
    Complained: 'COMPLAINED' as StateType,
    InventoryFailure: 'INVENTORY_FAILURE' as StateType,
    Stored: 'STORED' as StateType
};

